export default __webpack_public_path__ + "static/media/mr.67c8306c.svg";